import {Exclude, Expose} from "class-transformer";
import {AbstractDictionaryApiModel} from "./abstract-dictionary.api-model";

@Exclude()
export class CountryApiModel extends AbstractDictionaryApiModel {
  @Expose() public code: string;
}
